import React, {Component} from 'react'
import PageTitle from "../../layout/PageTitle";
import DateUtil from "../../utils/DateUtil";
import BillingService from "../../services/billing/BillingService";
import RemotingService from "../../services/remoting-service/RemotingService";
import {Column} from "primereact/column";
import EnumBillTypeShort from "../patient/enums/EnumBillTypeShort";
import {DataTable} from "primereact/datatable";
import moment from "moment";
import {Link} from "react-router-dom";
import './Billing.css'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {Dropdown as PrimeDropdown} from "primereact/components/dropdown/Dropdown";
import {Button} from "react-bootstrap";
import FileUtil from "../../utils/FileUtil";
import {DateInput} from "../../components";
import PrimeDateInput from "../../components/date-input/PrimeDateInput";
import ActionMenu from "../../components/action-menu/ActionMenu";
import ActionMenuItem from "../../components/action-menu/ActionMenuItem";
import CancelIcon from "../../components/action-menu/icons/CancelIcon";
import ConfirmIcon from "../../components/action-menu/icons/ConfirmIcon";
import confirmDialog from "../../components/dialog/ConfirmDialog";
import ExpansionPanel from "../../components/expansion-panel/CustomExpansionPanel";
import DelayedTextInput from "../../components/text-input/DelayedTextInput";
import EnumInsurancePaymentStatus from "./enums/EnumInsurancePaymentStatus";
import AuthService from "../../services/auth-service/AuthService";
import ViewIcon from "../../components/action-menu/icons/ViewIcon";
import AttachmentUtils from "../emr/recordpage/treatment/utils/AttachmentUtils";
import {downloadBlob} from "../../utils/FileDownloader";
import PrintIcon from "../../components/action-menu/icons/PrintIcon";
import DownloadIcon from "../../components/action-menu/icons/DownloadIcon";
import ClockRotateIcon from "../../components/action-menu/icons/ClockRotateIcon";
import EditIcon from "../../components/action-menu/icons/EditIcon";
import dialog from "../../components/dialog/Dialog";
import InvoiceEditModal from "./InvoiceEditModal";
import NotificationService from "../../services/notification-service/NotificationService";
import NumberUtils from "../../utils/NumberUtil";
import MoneyUtil from "../../utils/MoneyUtil";

const CASHIER_ID = 0;

export default class Billing extends Component {

    constructor(props) {
        super(props);

        // Opened from an invoice number link (e.g. Insurance > Generate Claims): land on that invoice
        const linkedInvoiceId = props.location && props.location.invoiceId;
        const linkedDate = linkedInvoiceId && props.location.invoiceDate ?
            moment(props.location.invoiceDate).toDate() : new Date();
        this.linkedInvoiceId = linkedInvoiceId;

        this.state = {
            staffs: [],
            revenuePerProviderStaffs: [],
            revenuePerProviderStartDate: new Date(),
            revenuePerProviderEndDate: new Date(),
            discWalletTrackerStartDate: new Date(),
            discWalletTrackerEndDate: new Date(),
            discWalletUsageStartDate: new Date(),
            discWalletUsageEndDate: new Date(),
            insuranceFollowUpStartDate: new Date(),
            insuranceFollowUpEndDate: new Date(),
            unpaidPaymentTrackerStartDate: new Date(),
            unpaidPaymentTrackerEndDate: new Date(),
            selectedStartDate: linkedDate,
            selectedEndDate: linkedDate,
            lastSearchedStartDate: linkedDate,
            lastSearchedEndDate: linkedDate,
            expandedInvoices: linkedInvoiceId ? {[linkedInvoiceId]: true} : null,
            dateRangeChanged: false,
            invoiceDateFilter: null,
            onlinePaymentInvoiceDateFilter: null,
            insurancePaymentInvoiceDateFilter: null,
        };
    }

    componentDidMount() {
        if (this.linkedInvoiceId) {
            this.allInvoicesTable.filter(String(this.linkedInvoiceId), 'id', 'equals');
        }
        this.retrieveStaffs();
    }

    retrieveStaffs() {
        RemotingService.getRemoteCall('api/staff/list-base', null, (result) => {
            let staffs = result.items;
            staffs.map(s => {
                s.label = s.name;
                s.value = s.id;
            });

            let revenuePerProviderStaffs = [{label: "Cashier", value: CASHIER_ID}, ...staffs];

            this.setState({
                staffs,
                revenuePerProviderStaffs,
                lastSearchedStartDate: this.state.selectedStartDate,
                lastSearchedEndDate: this.state.selectedEndDate
            }, () => {
                this.retrieveItems();
            });
        });
    }

    retrieveItems() {
        RemotingService.getRemoteCall('api/billing/item', null, (items) => {
            this.setState({items}, () => {
                this.retrieveInvoices();
                this.retrievePendingOnlinePaymentInvoices();
                this.retrievePendingInsurancePaymentInvoices();
            });
        });
    }

    retrieveInvoices() {
        RemotingService.getRemoteCall('api/billing/invoice/list',
            {
                startDate: moment(this.state.selectedStartDate).format('YYYY-MM-DD'),
                endDate: moment(this.state.selectedEndDate).format('YYYY-MM-DD'),
                notStatus: ["PENDING_ONLINE_PAYMENT"]
            },
            (result) => {
                result.items.map(i => BillingService.hydrateInvoice(i, this.state.items, this.state.staffs));
                this.setState({invoices: result.items});
            });
    }

    retrievePendingOnlinePaymentInvoices() {
        RemotingService.getRemoteCall('api/billing/invoice/list',
            {
                startDate: moment(this.state.selectedStartDate).format('YYYY-MM-DD'),
                endDate: moment(this.state.selectedEndDate).format('YYYY-MM-DD'),
                status: ["PENDING_ONLINE_PAYMENT"]
            },
            (result) => {
                result.items.map(i => BillingService.hydrateInvoice(i, this.state.items, this.state.staffs));
                this.setState({onlinePaymentPendingInvoices: result.items});
            });
    }

    retrievePendingInsurancePaymentInvoices() {
        RemotingService.getRemoteCall('api/billing/invoice/list',
            {
                startDate: moment(this.state.selectedStartDate).format('YYYY-MM-DD'),
                endDate: moment(this.state.selectedEndDate).format('YYYY-MM-DD'),
                insurancePaymentStatus: ["PENDING", "RESUBMITTED"]
            },
            (result) => {
                result.items.map(i => BillingService.hydrateInvoice(i, this.state.items, this.state.staffs));
                this.setState({insurancePaymentPendingInvoices: result.items});
            });
    }

    handleDateStateChange = () => {
        this.retrieveInvoices();
        this.retrievePendingOnlinePaymentInvoices();
        this.retrievePendingInsurancePaymentInvoices();
    }

    createRevenuePerProviderReport = () => {
        const params = {
            providerId: this.state.revenuePerProviderStaffId,
            start: this.state.revenuePerProviderStartDate,
            end: this.state.revenuePerProviderEndDate,
        };

        RemotingService.postRemoteCall('api/billing/report/revenue-per-provider', params, (reportFile) => {
            FileUtil.saveReportAs('revenue-per-provider', reportFile);
        });
    }

    createDiscWalletTrackerReport = () => {
        const params = {
            start: this.state.discWalletTrackerStartDate,
            end: this.state.discWalletTrackerEndDate,
        };

        RemotingService.postRemoteCall('api/billing/report/disc-wallet-tracker', params, (reportFile) => {
            FileUtil.saveReportAs('disc-wallet-tracker', reportFile);
        });
    }

    createDiscWalletUsageReport = () => {
        const params = {
            start: this.state.discWalletUsageStartDate,
            end: this.state.discWalletUsageEndDate,
        };

        RemotingService.postRemoteCall('api/billing/report/disc-wallet-usage', params, (reportFile) => {
            FileUtil.saveReportAs('disc-wallet-usage', reportFile);
        });
    }

    createInsuranceFollowUpReport = () => {
        const params = {
            start: this.state.insuranceFollowUpStartDate,
            end: this.state.insuranceFollowUpEndDate,
        };

        RemotingService.postRemoteCall('api/billing/report/insurance-follow-up', params, (reportFile) => {
            FileUtil.saveReportAs('insurance-follow-up', reportFile);
        });
    }

    createUnpaidPaymentTrackerReport = () => {
        const params = {
            providerId: this.state.unpaidPaymentTrackerStaffId,
            start: this.state.unpaidPaymentTrackerStartDate,
            end: this.state.unpaidPaymentTrackerEndDate,
        };

        RemotingService.postRemoteCall('api/billing/report/unpaid-payment-tracker', params, (reportFile) => {
            FileUtil.saveReportAs('unpaid-payment-tracker', reportFile);
        });
    }

    invoiceColumns = (filterType = 'default') => {
        const getDateFilter = () => {
            switch(filterType) {
                case 'onlinePayment':
                    return this.onlinePaymentInvoiceDateFilter();
                case 'insurancePayment':
                    return this.insurancePaymentInvoiceDateFilter();
                default:
                    return this.invoiceDateFilter();
            }
        };
        return [
            <Column expander={true} style={{width: '20px'}}/>,
            <Column style={{width: '115px'}} header="Invoice Number" field="id" filter={true} filterMatchMode="contains" sortable/>,
            <Column style={{width: '120px'}} header="Invoice Date" field="invoiceDate" filter={true}
                    filterElement={getDateFilter()} sortable
                    body={(invoice) => DateUtil.formatDateMMM(invoice.invoiceDate)}/>,
            <Column style={{width: '75px'}} header="Bill Type" field="billType" body={(invoice) => EnumBillTypeShort[invoice.billType]}
                    sortable/>,
            <Column style={{width: '105px'}} header="MRN Number" field="patientMrn" filter={true} filterMatchMode="contains" sortable/>,
            <Column style={{width: '105px'}} header="Patient Name" field="patientName" filter={true} filterMatchMode="contains" body={(invoice) =>
                <Link to={{
                    pathname: '/patientdetail/' + invoice.patientId,
                    selectedView: 'billing'
                }}>{invoice.patientName}</Link>} sortable/>,
            <Column header="Provider" field="providerName" filter={true} filterMatchMode="contains" sortable/>,
            <Column header="Referred By" field="referrer" sortable/>,
            <Column style={{width: '165px'}} className="text-break" header="Insurance Approval Code" field="insuranceApprovalCode" filter={true} filterMatchMode="contains" sortable/>,
            <Column style={{width: '75px'}}header="Bill Status" field="status" body={BillingService.billStatusTemplate}
                    className="text-center"/>,
            <Column style={{width: '105px'}} header="Total Amount" field="total" body={BillingService.moneyTemplate("net")} sortable/>,
            <Column style={{width: '115px'}} header="Patient Payable" field="patientPayable" body={BillingService.moneyTemplate("patientPayable")} sortable/>,
            <Column header="Payment" field="paymentType" style={{width: 125}}/>,
            <Column header="Notes" field="notes"/>
        ]
    }

    confirmInvoicePayment = (invoice) => {
        confirmDialog("Confirm Invoice Payment",
            "You are about to confirm payment for this invoice. Are you sure?",
            () => {
                RemotingService.postRemoteCall(
                    `api/billing/invoice/${invoice.id}/confirm-payment`,
                    null,
                    (invoice) => {
                        this.retrieveInvoices();
                        this.retrievePendingOnlinePaymentInvoices();
                    });
            });
    }

    cancelInvoice = (invoice) => {
        confirmDialog("Cancel Invoice Payment",
            "You are about to cancel a payment pending invoice. Are you sure?",
            () => {
                RemotingService.postRemoteCall(
                    `api/billing/invoice/${invoice.id}/cancel?reason=${this.state.cancelReason}&detail=${this.state.cancelDetail}`,
                    null,
                    (invoice) => {
                        this.retrieveInvoices();
                        this.retrievePendingOnlinePaymentInvoices();
                    });
            });
    }

    updatePaymentInvoice = (invoice, field, value) => {
        const {creditReceived, insurancePaymentStatus} = invoice;
        const updateDto = {creditReceived, insurancePaymentStatus};
        updateDto[field] = value;

        RemotingService.postRemoteCall(
            `api/billing/invoice/${invoice.id}/insurance-payment-update`,
            updateDto,
            (invoice) => {
                this.retrieveInvoices();
                this.retrievePendingInsurancePaymentInvoices();
            });
    }

    renderTitle = (title) => {
        return <PageTitle title={title} className="py-3 pl-4 mx-0 mb-1" labelClassName="font-weight-bold"/>
    }

    downloadPdfFile(pdfPath, fileName) {
        RemotingService.instance.get('api/file/download/' + pdfPath, {responseType: 'blob'})
            .then((response) => {
                downloadBlob(new Blob([response.data]), fileName);
            });
    }

    viewPdfFile(pdfPath, fileName) {
        RemotingService.instance.get('api/file/download/' + pdfPath, {responseType: 'blob'})
            .then((response) => {
                AttachmentUtils.viewFile({
                    fileName: fileName, blob: response.data, id: "invoiceViewer",
                    windowWidth: "1200x", windowHeight: "800px"
                });
            });
    }

    getInvoiceFileName(invoice) {
        return 'invoice_' + invoice.id + '_' + DateUtil.formatDateTimeSeparatelyForFileStamp(new Date()) + '.pdf';
    }

    getReceiptFileName(invoice) {
        return 'receipt_' + invoice.id + '_' + DateUtil.formatDateTimeSeparatelyForFileStamp(new Date()) + '.pdf';
    }

    downloadInvoicePdf(invoice) {
        this.downloadPdfFile(invoice.pdfPath, this.getInvoiceFileName(invoice));
    }

    viewInvoicePdf(invoice) {
        this.viewPdfFile(invoice.pdfPath, this.getInvoiceFileName(invoice));
    }

    printInvoicePdf(invoice) {
        this.viewPdfFile(invoice.pdfPath, this.getInvoiceFileName(invoice));
    }

    downloadReceiptPdf(invoice) {
        this.downloadPdfFile(invoice.receiptPdfPath, this.getReceiptFileName(invoice));
    }

    viewReceiptPdf(invoice) {
        this.viewPdfFile(invoice.receiptPdfPath, this.getReceiptFileName(invoice));
    }

    printReceiptPdf(invoice) {
        this.viewPdfFile(invoice.receiptPdfPath, this.getReceiptFileName(invoice));
    }

    regenerateInvoicePdf(invoice) {
        confirmDialog(
            "Regenerate Invoice PDF",
            "Are you sure you want to regenerate the invoice PDF? Old pdf will be deleted and the new PDF will reflect the current invoice data. The old PDF will only be accessible by the technical team.",
            () => {
                RemotingService.postRemoteCall('api/billing/invoice/' + invoice.id + '/regenerate-pdf', null, () => {
                    NotificationService.showNotification({
                        severity: 'success',
                        summary: 'Invoice PDF Regenerated',
                        detail: 'The invoice PDF has been regenerated successfully.'
                    });
                    this.retrieveInvoices();
                });
            }
        );
    }

    openInvoiceEditor(invoice) {
        dialog({
            title: "Edit Invoice #" + invoice.id,
            maxWidth: "xl",
            component: <InvoiceEditModal invoiceId={invoice.id} onSaved={() => this.retrieveInvoices()}/>
        });
    }

    handleSelectedStartDateChange(date) {
        const newState = DateUtil.isAfter(date, this.state.selectedEndDate) ?
            {selectedStartDate: date, selectedEndDate: date, dateRangeChanged: true} :
            {selectedStartDate: date, dateRangeChanged: true};
        this.setState(newState);
    }

    handleSelectedEndDateChange(date) {
        const newState = DateUtil.isBefore(date, this.state.selectedStartDate) ?
            {selectedEndDate: this.state.selectedStartDate, dateRangeChanged: true} :
            {selectedEndDate: date, dateRangeChanged: true};
        this.setState(newState);
    }

    handleSearchInvoices = () => {
        this.setState({
            lastSearchedStartDate: this.state.selectedStartDate,
            lastSearchedEndDate: this.state.selectedEndDate,
            dateRangeChanged: false
        }, () => {
            this.handleDateStateChange();
        });
    }

    preparePageTitle() {
        return `${DateUtil.formatDateDo(this.state.lastSearchedStartDate)} - ${DateUtil.formatDateDo(this.state.lastSearchedEndDate)}`;
    }

    textInputTemplate = (invoiceItem, fieldName) => {
        return (invoiceItem[fieldName] === undefined || invoiceItem[fieldName] === null) ? 0 :
                NumberUtils.toFixed(invoiceItem[fieldName], MoneyUtil.getFractionDigitsWithCountry(invoiceItem["clinic"].country))
    }

    onInvoiceDateFilterChange = (val) => {
        const formattedDate = DateUtil.formatDate(val, "YYYY-MM-DD");
        this.allInvoicesTable.filter(formattedDate, 'invoiceDate', formattedDate ? 'equals' : null);
        this.setState({invoiceDateFilter: formattedDate});
    }

    onOnlinePaymentInvoiceDateFilterChange = (val) => {
        const formattedDate = DateUtil.formatDate(val, "YYYY-MM-DD");
        this.onlinePaymentTable.filter(formattedDate, 'invoiceDate', formattedDate ? 'equals' : null);
        this.setState({onlinePaymentInvoiceDateFilter: formattedDate});
    }

    onInsurancePaymentInvoiceDateFilterChange = (val) => {
        const formattedDate = DateUtil.formatDate(val, "YYYY-MM-DD");
        this.insurancePaymentTable.filter(formattedDate, 'invoiceDate', formattedDate ? 'equals' : null);
        this.setState({insurancePaymentInvoiceDateFilter: formattedDate});
    }

    invoiceDateFilter = () => {
        return <PrimeDateInput className="w-100" inputClassName="p-0" clearable
                               value={this.state.invoiceDateFilter}
                               onChange={this.onInvoiceDateFilterChange}/>
    }

    onlinePaymentInvoiceDateFilter = () => {
        return <PrimeDateInput className="w-100" inputClassName="p-0" clearable
                               value={this.state.onlinePaymentInvoiceDateFilter}
                               onChange={this.onOnlinePaymentInvoiceDateFilterChange}/>
    }

    insurancePaymentInvoiceDateFilter = () => {
        return <PrimeDateInput className="w-100" inputClassName="p-0" clearable
                               value={this.state.insurancePaymentInvoiceDateFilter}
                               onChange={this.onInsurancePaymentInvoiceDateFilterChange}/>
    }

    render() {
        return (
            <>
                <div style={{padding: '15px 15px 5px 15px'}}
                     className="data-table-header-wrapper"> {/*Remove this class and date navigation won't work.}*/}
                    <div className="float-left">
                        <PageTitle title={this.preparePageTitle()} className="bg-white"/>
                    </div>
                    <div className="float-right">
                        <div className={"row"}>
                            <div style={{margin: '10px'}}>
                                <label className={"mr-2"}>Start Date:</label>
                                <DateInput value={this.state.selectedStartDate}
                                           onChange={(date) => this.handleSelectedStartDateChange(date)}/>
                            </div>
                            <div style={{margin: '10px'}}>
                                <label className={"mr-2"}>End Date:</label>
                                <DateInput value={this.state.selectedEndDate}
                                           onChange={(date) => this.handleSelectedEndDateChange(date)}/>
                            </div>
                            <div style={{margin: '10px'}}>
                                <Button variant="primary" onClick={this.handleSearchInvoices}>
                                    Search
                                </Button>
                            </div>
                        </div>
                        <div className={"row"}
                             style={{marginTop: '2px', minHeight: '16px', justifyContent: 'flex-end'}}>
                            <div style={{
                                margin: '0 10px',
                                fontSize: '12px',
                                color: '#dc3545',
                                height: '14px',
                                lineHeight: '14px'
                            }}>
                                {this.state.dateRangeChanged ? 'Click "Search" for the new date range' : ""}
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{padding: '5px'}}>
                    {this.renderTitle("All Invoices")}
                    <DataTable className="InvoiceTable" responsive paginator={true} rows={10}
                               emptyMessage={"No results found"}
                               value={this.state.invoices}
                               ref={(el) => this.allInvoicesTable = el}
                               expandedRows={this.state.expandedInvoices}
                               rowExpansionTemplate={(invoice) => BillingService.invoiceItemsExpansionTemplate(invoice, true, this.textInputTemplate, false, true)}
                               onRowToggle={(e) => {
                                   this.setState({
                                       ...this.state,
                                       expandedInvoices: e.data,
                                   })
                               }}
                               rowClassName={BillingService.disabledRowClassFunction}
                               dataKey="id">
                        {this.invoiceColumns('default')}
                        <Column style={{width: '65px'}} header="Credit" field="credit" body={BillingService.moneyTemplate("credit")} sortable/>
                        <Column style={{width: '115px'}} header="Credit Received" field="creditReceived" body={BillingService.moneyTemplate("creditReceived")} sortable/>
                        <Column style={{width: '145px'}} header="Reconciliation Status" field="insurancePaymentStatus"
                                body={BillingService.insurancePaymentStatusTemplate} sortable/>
                        <Column style={{width: '50px'}} header="Actions" body={(invoice) => {
                            return invoice.pdfPath || AuthService.userHasAuthority("EDIT_BILLING_INVOICE") ?
                                <ActionMenu id="invoiceActionPanel">
                                    {invoice.pdfPath &&
                                    <ActionMenuItem
                                        icon={<ViewIcon/>}
                                        onClick={() => {
                                            this.viewInvoicePdf(invoice)
                                        }} text={"View"}/>}
                                    {invoice.pdfPath &&
                                    <ActionMenuItem
                                        icon={<PrintIcon/>}
                                        onClick={() => {
                                            this.printInvoicePdf(invoice)
                                        }} text={"Print"}/>}
                                    {invoice.pdfPath &&
                                    <ActionMenuItem
                                        icon={<DownloadIcon/>}
                                        onClick={() => {
                                            this.downloadInvoicePdf(invoice)
                                        }} text={"Download"}/>}
                                    {invoice.receiptPdfPath ?
                                        <ActionMenuItem
                                            icon={<ViewIcon/>}
                                            onClick={() => {
                                                this.viewReceiptPdf(invoice)
                                            }} text={"View Receipt"}/> : null}
                                    {invoice.receiptPdfPath ?
                                        <ActionMenuItem
                                            icon={<PrintIcon/>}
                                            onClick={() => {
                                                this.printReceiptPdf(invoice)
                                            }} text={"Print Receipt"}/> : null}
                                    {invoice.receiptPdfPath ?
                                        <ActionMenuItem
                                            icon={<DownloadIcon/>}
                                            onClick={() => {
                                                this.downloadReceiptPdf(invoice)
                                            }} text={"Download Receipt"}/> : null}
                                    {invoice.pdfPath &&
                                    <ActionMenuItem
                                        icon={<ClockRotateIcon/>}
                                        onClick={() => {
                                            this.regenerateInvoicePdf(invoice)
                                        }} text={"Regenerate Invoice"}/>}
                                    <ActionMenuItem
                                        icon={<EditIcon/>}
                                        authority="EDIT_BILLING_INVOICE"
                                        disabled={'CANCELLED' === invoice.status || 'DELETED' === invoice.status}
                                        onClick={() => {
                                            this.openInvoiceEditor(invoice)
                                        }} text={"Edit Invoice"}/>
                                </ActionMenu>: ""
                        }}/>
                    </DataTable>
                </div>
                <div style={{padding: '5px'}}>
                    {this.renderTitle("Invoices Waiting for Online Payment")}
                    <DataTable className="InvoiceTable" responsive paginator={true} rows={10}
                               emptyMessage={"No results found"}
                               value={this.state.onlinePaymentPendingInvoices}
                               ref={(el) => this.onlinePaymentTable = el}
                               expandedRows={this.state.expandedPendingInvoices}
                               rowExpansionTemplate={(invoice) => BillingService.invoiceItemsExpansionTemplate(invoice, true, this.textInputTemplate, false, true)}
                               onRowToggle={(e) => {
                                   this.setState({
                                       ...this.state,
                                       expandedPendingInvoices: e.data,
                                   })
                               }}
                               rowClassName={BillingService.disabledRowClassFunction}
                               dataKey="id">
                        {this.invoiceColumns('onlinePayment')}
                        <Column header="" body={(invoice) => {
                            return (<ActionMenu id="pendingInvoiceActionPanel">
                                <ActionMenuItem
                                    icon={<ConfirmIcon/>}
                                    onClick={() => {
                                        this.confirmInvoicePayment(invoice)
                                    }} text={"Confirm Payment"}/>
                                <ActionMenuItem
                                    icon={<CancelIcon/>}
                                    onClick={() => {
                                        this.cancelInvoice(invoice)
                                    }} text={"Cancel"}/>
                            </ActionMenu>)
                        }}/>
                    </DataTable>
                </div>
                <div style={{padding: '5px'}}>
                    {this.renderTitle("Invoices Waiting for Insurance Payment")}
                    <DataTable className="InvoiceTable" responsive paginator={true} rows={10}
                               emptyMessage={"No results found"}
                               value={this.state.insurancePaymentPendingInvoices}
                               ref={(el) => this.insurancePaymentTable = el}
                               expandedRows={this.state.expandedInsurancePendingInvoices}
                               rowExpansionTemplate={(invoice) => BillingService.invoiceItemsExpansionTemplate(invoice, true, this.textInputTemplate, false, true)}
                               onRowToggle={(e) => {
                                   this.setState({
                                       ...this.state,
                                       expandedInsurancePendingInvoices: e.data,
                                   })
                               }}
                               rowClassName={BillingService.disabledRowClassFunction}
                               dataKey="id">
                        {this.invoiceColumns('insurancePayment')}
                        <Column style={{width: '65px'}}  header="Credit" field="credit" body={BillingService.moneyTemplate("credit")} sortable/>
                        <Column  style={{width: '115px'}} header="Credit Received" field="creditReceived" sortable
                                body={(invoice) =>
                                    <DelayedTextInput style={{width: '75px'}}
                                                      value={invoice.creditReceived}
                                                      onChange={(value) => this.updatePaymentInvoice(invoice, 'creditReceived', value)}/>}
                        />
                        <Column style={{width: '115px'}}  header="Reconciliation Status" field="insurancePaymentStatus"
                                body={(invoice) =>
                                    <PrimeDropdown optionLabel="name" optionValue="key"
                                                   options={EnumInsurancePaymentStatus.toArray()}
                                                   value={invoice.insurancePaymentStatus}
                                                   onChange={event => this.updatePaymentInvoice(invoice, 'insurancePaymentStatus', event.value)}
                                                   style={{width: '100%'}}/>} sortable/>
                    </DataTable>
                </div>
                {AuthService.userHasAuthority("VIEW_BILLING_REPORT") &&
                    <div style={{padding: '5px'}}>
                    {this.renderTitle("Reports")}
                    <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                            Revenue Per Provider Report
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className="d-flex justify-content-between align-items-center">
                            <div className={"col"}>
                                <label className={"mr-2"}> Provider:</label>

                                <PrimeDropdown options={this.state.revenuePerProviderStaffs} value={this.state.revenuePerProviderStaffId}
                                               style={{width: '250px'}}
                                               onChange={(e) => {
                                                   this.setState({revenuePerProviderStaffId: e.target.value})
                                               }}/>
                            </div>

                            <div className={"col"}>
                                <label className={"mr-2"}>Invoice Date Start:</label>

                                <DateInput value={this.state.revenuePerProviderStartDate}
                                           onChange={date => {
                                               this.setState({revenuePerProviderStartDate: date})
                                           }}/>
                            </div>
                            <div className={"col"}>
                                <label className={"mr-2"}> Invoice Date End:</label>

                                <DateInput value={this.state.revenuePerProviderEndDate}
                                           onChange={date => {
                                               this.setState({revenuePerProviderEndDate: date})
                                           }}/>
                            </div>

                            <Button onClick={() => this.createRevenuePerProviderReport()}>
                                Download As XLS
                            </Button>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                            DISC Wallet Report
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className="d-flex justify-content-between align-items-center">

                            <div className={"col"}>
                                <label className={"mr-2"}>Start Date:</label>

                                <DateInput value={this.state.discWalletTrackerStartDate}
                                           onChange={date => {
                                               this.setState({discWalletTrackerStartDate: date})
                                           }}/>
                                <label className={"mr-2 ml-2"}>End Date:</label>

                                <DateInput value={this.state.discWalletTrackerEndDate}
                                           onChange={date => {
                                               this.setState({discWalletTrackerEndDate: date})
                                           }}/>
                            </div>


                            <Button onClick={() => this.createDiscWalletTrackerReport()}>
                                Download As XLS
                            </Button>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                            DISC Wallet Usage Report
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className="d-flex justify-content-between align-items-center">
                            <div className={"col"}>
                                <label className={"mr-2"}> Start Date:</label>

                                <DateInput value={this.state.discWalletUsageStartDate}
                                           onChange={date => {
                                               this.setState({discWalletUsageStartDate: date})
                                           }}/>
                                <label className={"mr-2 ml-2"}> End Date:</label>

                                <DateInput value={this.state.discWalletUsageEndDate}
                                           onChange={date => {
                                               this.setState({discWalletUsageEndDate: date})
                                           }}/>

                            </div>

                            <Button onClick={() => this.createDiscWalletUsageReport()}>
                                Download As XLS
                            </Button>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                            Insurance Follow Up Report
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className="d-flex justify-content-between align-items-center">
                            <div className={"col"}>
                                <label className={"mr-2"}> Start Date:</label>
                                <DateInput value={this.state.insuranceFollowUpStartDate}
                                           onChange={date => {
                                               this.setState({insuranceFollowUpStartDate: date})
                                           }}/>
                                <label className={"mr-2 ml-2"}>End Date:</label>

                                <DateInput value={this.state.insuranceFollowUpEndDate}
                                           onChange={date => {
                                               this.setState({insuranceFollowUpEndDate: date})
                                           }}/>
                            </div>
                            <Button onClick={() => this.createInsuranceFollowUpReport()}>
                                Download As XLS
                            </Button>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                            Unpaid Payment Tracker Report
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className="d-flex justify-content-between align-items-center">
                            <div className={"col"}>
                                <label className={"mr-2"}>Provider:</label>
                                <PrimeDropdown options={this.state.staffs}
                                               value={this.state.unpaidPaymentTrackerStaffId}

                                               style={{width: '250px'}}
                                               onChange={(e) => {
                                                   this.setState({unpaidPaymentTrackerStaffId: e.target.value})
                                               }}/>
                            </div>
                            <div className={"col"}>
                                <label className={"mr-2"}>Invoice Date Start:</label>
                                <DateInput value={this.state.unpaidPaymentTrackerStartDate}
                                           defaultValue="Normal"
                                           onChange={date => {
                                               this.setState({unpaidPaymentTrackerStartDate: date})
                                           }}/>
                            </div>
                            <div className={"col"}>
                                <label className={"mr-2"}>Invoice Date End: </label>
                                <DateInput value={this.state.unpaidPaymentTrackerEndDate}

                                           onChange={date => {
                                               this.setState({unpaidPaymentTrackerEndDate: date})
                                           }}/>
                            </div>
                            <Button onClick={() => this.createUnpaidPaymentTrackerReport()}>
                                Download As XLS
                            </Button>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
                }
            </>
        )
    }

}
